export const ColorPickerSvg = ({ className }: { className?: string }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4465 17.0135L12.9348 19.0913L12.4465 20.9782C11.3103 20.9782 9.93325 21.243 8.94302 20.8375C7.89272 20.4075 7.24087 19.2845 6.45117 18.4948L7.42773 16.5419L9.25513 15.6914C10.0715 16.5083 11.2001 17.0135 12.4465 17.0135Z"
      fill="#EE61EB"
    />
    <path
      d="M9.25529 15.6914V15.6919L6.45134 18.4953C5.68425 17.7282 4.57517 16.8636 4.14611 15.8493C3.71701 14.8349 3.96794 13.6707 3.96794 12.5L6.07106 12.0117L7.93317 12.5C7.93322 13.7458 8.4384 14.8744 9.25529 15.6914Z"
      fill="#0065A3"
    />
    <path
      d="M9.2551 9.30879C8.4382 10.1257 7.93298 11.2543 7.93298 12.5002H3.96775C3.96775 11.4448 3.62351 10.0926 3.9759 9.1606C4.40525 8.025 5.60852 7.34751 6.45114 6.50488L8.52878 7.60601L9.2551 9.30879Z"
      fill="#99EEFF"
    />
    <path
      d="M12.4465 4.02122L12.9348 6.00575L12.4465 7.98592C11.1997 7.98592 10.0715 8.49163 9.25513 9.30853L6.45117 6.50457C7.21826 5.73748 7.64351 4.62835 8.65791 4.19925C9.67231 3.7702 11.2759 4.02122 12.4465 4.02122V4.02122Z"
      fill="#93E300"
    />
    <path
      d="M18.4418 6.50442L17.4601 8.46277L15.6384 9.30784C14.8215 8.49095 13.6929 7.98572 12.4465 7.98572V4.02103C13.5757 4.02103 15.1416 3.75354 16.1269 4.15428C17.1844 4.5844 17.6473 5.71014 18.4418 6.50442V6.50442Z"
      fill="#FFF375"
    />
    <path
      d="M20.9258 12.5002L18.929 12.9885L16.9605 12.5002C16.9605 11.2538 16.4554 10.1252 15.6384 9.3083L18.4418 6.50488H18.4424C19.2367 7.29917 20.3624 7.76211 20.7925 8.81973C21.1933 9.80503 20.9258 11.371 20.9258 12.5002Z"
      fill="#FFC34D"
    />
    <path
      d="M20.9258 12.5C20.9258 13.6292 21.5352 15.0487 21.1345 16.0339C20.7042 17.0917 19.2365 17.7012 18.4418 18.4954L16.5911 17.6212L15.6384 15.6919C16.4553 14.875 16.9605 13.7464 16.9605 12.5H20.9258V12.5Z"
      fill="#FF3377"
    />
    <path
      d="M18.4419 18.4949C17.6745 19.262 16.9075 20.3711 15.8932 20.8002C14.8789 21.2292 13.6172 20.9783 12.4465 20.9783V17.0135C13.6929 17.0135 14.8215 16.5083 15.6384 15.6914L18.4419 18.4949Z"
      fill="#FF5CA8"
    />
    <path
      d="M12.4465 20.9786L12.9348 23.0629L12.4465 24.9993C9.002 24.9853 5.88682 23.5781 3.63477 21.3115L4.54678 19.4229L6.45117 18.4951C7.9854 20.0294 10.1052 20.9786 12.4465 20.9786V20.9786Z"
      fill="#C331C8"
    />
    <path
      d="M21.3117 21.3649C19.0518 23.6113 15.9382 24.9998 12.5 24.9998C12.4823 24.9998 12.4642 24.9998 12.4465 24.9993V20.9785C14.7878 20.9785 16.9071 20.0293 18.4418 18.4951L20.5135 19.5902L21.3117 21.3649Z"
      fill="#FF3377"
    />
    <path
      d="M25 12.5C25 15.9652 23.5897 19.1017 21.3117 21.3651L18.4419 18.4953C19.9767 16.9616 20.9258 14.8418 20.9258 12.5L22.998 12.0117L25 12.5Z"
      fill="#E50048"
    />
    <path
      d="M25 12.4999H20.9258C20.9258 10.1586 19.9766 8.03882 18.4424 6.50459L19.407 4.56318L21.3117 3.63477C23.5897 5.89824 25 9.03467 25 12.4999Z"
      fill="#FF9933"
    />
    <path
      d="M21.3117 3.63486L18.4424 6.50469H18.4418C16.9071 4.97046 14.7878 4.02129 12.4465 4.02129L11.9583 2.19731L12.4465 0.000537109C12.4642 0 12.4823 0 12.5 0C15.9382 0 19.0518 1.38848 21.3117 3.63486V3.63486Z"
      fill="#FFDE46"
    />
    <path
      d="M12.4465 0.000976562V4.02173C10.1052 4.02173 7.9854 4.9709 6.45117 6.50513L4.57944 5.60996L3.63477 3.68872C5.88682 1.42212 9.002 0.0149414 12.4465 0.000976562V0.000976562Z"
      fill="#00DA26"
    />
    <path
      d="M6.45127 6.50488C4.91699 8.03911 3.96782 10.1589 3.96782 12.5002L1.83921 12.9885L0 12.5002C0 9.06191 1.38848 5.94834 3.63486 3.68848L6.45127 6.50488Z"
      fill="#33DDFF"
    />
    <path
      d="M6.45127 18.4953L3.63486 21.3117C1.38848 19.0519 0 15.9383 0 12.5H3.96782C3.96782 14.8413 4.91699 16.9611 6.45127 18.4953Z"
      fill="#194D80"
    />
  </svg>
);
